import { css } from '@emotion/css';
export { css, cx, injectGlobal, keyframes } from '@emotion/css';
export { default as etiColors } from './colors';
export { getTextStyles } from './typography';
export { default as mediaQueries } from './constants/mediaQueries';
export const resetButtonStyle = css`
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  outline: none;
  padding: 0;
`;
//# sourceMappingURL=index.js.map